import * as i18n from 'i18n-for-browser';
import moment from 'moment';
import { cookie } from 'glxl-helpers';
import apiCall from './components/apiCall';
import langStrings from './assets/lang.json';
import getUrlVars from './helpers/getUrlVars';

const c = 'i18n';

const init = apiCall('/language/translations?simulationgame=true')
.then((translations) => {
  window.translations = translations;
  i18n.configure({
    locales: {
      ...langStrings,
      ...translations,
    },
    cookie: c,
  });
  let { lang: langFromUri } = getUrlVars();
  if (langFromUri === 'be') {
    langFromUri = 'nl';
  }
  if (langFromUri && translations[langFromUri]) {
    setLanguage(langFromUri);
    cookie.setCookie(c, langFromUri);
  } else {
    // Default to NL
    if (!cookie.getCookie(c)) {
      setLanguage('nl');
      cookie.setCookie(c, 'nl');
    }
  }
  moment.locale(i18n.getLocale());
})
.catch(() => {
  throw new Error('Error during fetching of translations');
});

const setLanguage = (lang) => {
  i18n.setLocale(lang);
  moment.locale(i18n.getLocale());
};

export default {
  init,
  setLanguage,
};



// WEBPACK FOOTER //
// ./src/lang.js